import type { FC } from "react";
import { useSearchParams } from "react-router-dom";
import ClientSecurities from "../../organisms/client/ClientSecurities";
import ListTabBar from "../../molecules/ListTabBar";
import { HorizontalSpacer } from "../../atoms/Spacers";
import ClientDocuments from "../../organisms/client/ClientDocuments";

interface Props {
  clientIdentifier: string;
}

const DEFAULT_TAB = "documents";

const tabs: Array<{ id: string; tabLabelKey: string }> = [
  {
    id: "documents",
    tabLabelKey: "clientFiles.documents",
  },
  {
    id: "securities",
    tabLabelKey: "clientFiles.securities",
  },
];

const ClientFilesPage: FC<Props> = ({ clientIdentifier }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTab =
    tabs.find((tab) => tab.id === searchParams.get("tab"))?.id ?? DEFAULT_TAB;

  const setSelectedTab = (tab: string) => {
    setSearchParams((prev) => {
      prev.set("tab", tab);
      return prev;
    });
  };

  return (
    <div>
      <ListTabBar
        tabs={tabs}
        onSelectTabId={setSelectedTab}
        selectedId={selectedTab}
      />
      <HorizontalSpacer spacing={2} />
      {selectedTab === "documents" && (
        <div>
          <ClientDocuments clientIdentifier={clientIdentifier} />
        </div>
      )}
      {selectedTab === "securities" && (
        <ClientSecurities clientIdentifier={clientIdentifier} />
      )}
    </div>
  );
};

export default ClientFilesPage;
